module.exports = __webpack_public_path__ + "assets/img/loginIcon2bak.1effa8e2.png";